
import { Injector, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScAuditHistoryComponent } from './audit-history.component';
import { FormbirdAngularSharedModule } from '@formbird/angular-shared';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {DocumentDownloaderModule} from '../../../../sc-document-downloader/src/app/document-downloader/document-downloader.module';
import { MatSliderModule } from '@angular/material/slider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatBadgeModule} from '@angular/material/badge';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [ScAuditHistoryComponent],
  declarations: [
    ScAuditHistoryComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTooltipModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatSliderModule,
    MatBadgeModule,
    FormbirdAngularSharedModule,
    DocumentDownloaderModule
  ],
  exports: [
    ScAuditHistoryComponent
  ]
})
export class ScAuditHistoryModule {

  constructor(
    private injector: Injector
  ) {
    this.convertToCustomElement(
      ScAuditHistoryComponent, 'sc-audit-history', this.injector
    );
    this.convertToCustomElement(
      ScAuditHistoryComponent, 'sc-audit-history-web-component', this.injector
    );
    console.log('Installed sc-audit-history-web-component');
  }

  convertToCustomElement = (component: any, selector: string, injector: any) => {
    if (!customElements.get(selector)) {
      const scComponent = createCustomElement(component, { injector });
      customElements.define(selector, scComponent);
    }
  }

}
